import React from 'react';

export default function useLoadingEffect() {
  const [showLoadingEffect, toggleLoadingEffect] = React.useState(false);

  React.useEffect(() => {
    const t = setTimeout(() => {
      console.log('Loading effect ended');
      toggleLoadingEffect(true);
    }, 250);

    return () => clearTimeout(t);
  }, []);

  return showLoadingEffect;
}
